export default __webpack_public_path__ + "static/media/Miscellaneous09.7f99959b.jpg";